import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  wrap: {
    padding: "0 12px 10px",
    backgroundColor: "#1e2229",
    borderBottom: "1px solid #404754"
  },
  input: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#2c3139",
      color: "#e2e8f0",
      borderRadius: 10,
      fontSize: 14,
      "& fieldset": {
        borderColor: "#404754"
      },
      "&:hover fieldset": {
        borderColor: "#5a7289"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#185FA5"
      }
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#64748b",
      opacity: 1
    }
  }
});

const DeckSearchBar = ({
  value,
  onChange
}: {
  value: string;
  onChange: (value: string) => void;
}) => {
  const classes = useStyles();

  return (
    <div className={classes.wrap}>
      <TextField
        className={classes.input}
        fullWidth
        size="small"
        placeholder="Search characters, pinyin, meaning…"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "#64748b", fontSize: 20 }} />
              </InputAdornment>
            ),
            "aria-label": "Search deck"
          }
        }}
      />
    </div>
  );
};

export default DeckSearchBar;
